import { useEffect } from 'react';
import { apiBase } from '../../lib/api';
import { useSearchParams } from 'react-router-dom';
import { tokens } from '../../theme';

const API_BASE = apiBase();

export function LoginVerify() {
  const [params] = useSearchParams();

  useEffect(() => {
    document.body.classList.add('studio-blue');
    const token = params.get('token');
    if (!token) return;
    // Browser follows the 302 from the worker, which sets the brand cookie
    // (Domain=.imorbis.com) and lands the user at /app.
    window.location.href = `${API_BASE}/auth/magic-link/verify?token=${encodeURIComponent(
      token
    )}`;
    return () => document.body.classList.remove('studio-blue');
  }, [params]);

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        fontFamily: tokens.font.display,
        fontSize: 18,
        fontWeight: 500,
        color: tokens.color.ink[500],
        background: tokens.color.paper[50],
      }}
    >
      Signing you in.
    </main>
  );
}
